import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  IconButton,
  PrimaryButton,
  Stack,
  TooltipHost,
} from '@fluentui/react';
import { showCustomToast } from 'common/components/CustomToast/utils';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ApprovalValues } from '../../../types';
import { setNodeScrollState } from '../../Conditions';

export const DeleteBranch: React.FC<{ data: any }> = ({ data }) => {
  const [showDialog, setShowDialog] = useState(false);
  const { getValues, setValue } = useFormContext<ApprovalValues>();
  const onDelete = () => {
    const approvalTrees = getValues('approvalTrees') || [];
    const updatedTrees = approvalTrees.map((tree, index) => {
      if (index !== data.levelIndex) return tree;
      const {
        levelIndex,
        levelName,
        approverBranchIndex,
        isFlowDeletable,
        isFlowUpdatable,
        ...dataWithoutIndex
      } = data;
      return {
        ...tree,
        approvalBranches: tree.approvalBranches
          ? tree.approvalBranches.filter((branch) => {
              const isEqual = Object.entries(dataWithoutIndex).every(
                ([key, value]) => branch[key as keyof typeof branch] === value
              );
              return !isEqual;
            })
          : null,
      };
    });
    setValue('approvalTrees', updatedTrees, {
      shouldDirty: true,
    });
    showCustomToast({
      content: 'Branch removed',
      appearance: 'info',
    });
    setNodeScrollState(true);
    setShowDialog(false);
  };

  return (
    <Stack>
      <TooltipHost content={'Delete'}>
        <IconButton
          iconProps={{ iconName: 'Delete' }}
          title="Delete Branch"
          ariaLabel="Delete Branch"
          onClick={() => {
            setNodeScrollState(false);
            setShowDialog(true);
          }}
          disabled={data?.isFlowUpdatable === false}
        />
      </TooltipHost>

      {showDialog && (
        <Dialog
          hidden={false}
          onDismiss={() => {
            setNodeScrollState(true);
            setShowDialog(false);
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: 'Delete Branch',
            subText: 'Are you sure you want to delete this branch?',
          }}
        >
          <DialogFooter>
            <PrimaryButton onClick={onDelete} text="Delete" />
            <DefaultButton
              onClick={() => {
                setNodeScrollState(true);
                setShowDialog(false);
              }}
              text="Cancel"
            />
          </DialogFooter>
        </Dialog>
      )}
    </Stack>
  );
};
